import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import PersonnelRolesTable from "@/components/operations/personnel-roles/personnel-roles-table";
import { RouteGuardPermissions } from "@/components/permissions/route-guard-multiple";

const personnelRolesSearchSchema = z.object({
  page: z.number().optional().default(1),
  search: z.string().optional(),
});

export const Route = createFileRoute(
  "/_authenticated/operations/personnel-roles",
)({
  validateSearch: personnelRolesSearchSchema,
  component: PersonnelRolesPage,
});

function PersonnelRolesPage() {
  const searchParams = Route.useSearch();

  return (
    <RouteGuardPermissions
      permissions={[{ module: "personnel_roles", actions: ["read", "update"] }]}
    >
      <div>
        <PersonnelRolesTable
          currentPage={searchParams.page}
          basePath="/operations/personnel-roles"
          searchParams={searchParams}
        />
      </div>
    </RouteGuardPermissions>
  );
}
